import { ProjectRepriceRequest, ProjectService, RepriceResponse } from 'entities';

export const getJoinedKey = (serviceId: string, country: string): string =>
  `${serviceId}#${country}`;

export function verifyFilling(
  repricedServices: ProjectRepriceRequest['repricedServices'],
  control: Record<string, boolean>,
): boolean {
  const keys = Object.keys(control);

  return (
    !!keys.length &&
    !!repricedServices?.every(({ id, costs }) => {
      const countries = costs.map(({ country }) => country);

      return countries.every((serviceCountry) => {
        return keys.find((key) => {
          const [serviceId, country] = key.split('#');

          return id === serviceId && serviceCountry === country;
        });
      });
    })
  );
}

export function updateServicesWithControl(
  repricedServices: NonNullable<ProjectRepriceRequest['repricedServices']>,
  control: Record<string, boolean>,
): NonNullable<ProjectRepriceRequest['repricedServices']> {
  return repricedServices.map(({ id, costs, ...rest }) => {
    const updatedCosts = costs.map(({ country, ...costData }) => ({
      ...costData,
      country,
      approved: control[getJoinedKey(id, country)],
    }));

    return {
      ...rest,
      id,
      costs: updatedCosts,
    };
  });
}

export function mergeServices(
  control: RepriceResponse,
  currentServices: ProjectService[],
  acceptControl: Record<string, boolean> = {},
): ProjectService[] {
  return currentServices.map((service) => {
    const controlService = (control || []).find(({ id }) => id === service.id);

    return {
      ...service,

      ...controlService,

      costs: {
        ...service.costs,

        ...Object.fromEntries(
          controlService?.costs.map((singleCountry) =>
            acceptControl[getJoinedKey(service.id, singleCountry.country)]
              ? [singleCountry.country, singleCountry.costs]
              : [singleCountry.country, service.costs[singleCountry.country]],
          ) ?? [],
        ),
      },
    };
  }) as ProjectService[];
}
